/**
 * LOADING.MODAL
 * Display loading
 */

import Modal from "@/components/modal"
import { withTranslation, WithTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"
import Space from "@/components/space"
import BubbleText from "@/components/BubbleText"

interface OwnProps {
  children?: any
  owlAssistantText?: string
}

type Props = OwnProps & WithTranslation

function LoadingModal(props: Props) {
  const { t } = props

  return props.owlAssistantText ? (
    <Modal displayOwl>
      <div className="relative flex flex-col items-start">
        <div className="mt-4 mb-10 ml-[120px] w-[300px]">
          <BubbleText text={props.owlAssistantText} />
          <div className="flex grey-t mt-[12px]">
            <Space />
            <FontAwesomeIcon icon={faCircleNotch} spin style={{ fontSize: 20 }} />
            &nbsp;
            {props.children ? props.children : t("utils_loading")}
          </div>
        </div>
      </div>
    </Modal>
  ) : (
    <Modal>
      <div className="height-20" />

      <div className="flex grey-t" style={{ fontSize: "32px" }}>
        <Space />
        <FontAwesomeIcon icon={faCircleNotch} spin />
        <Space />
      </div>

      <div className="height-20" />

      <div className="flex grey-t">
        <Space />
        {t("utils_loading")}
        <Space />
      </div>

      {props.children}
    </Modal>
  )
}

export default withTranslation()(LoadingModal)
